var VIDEO_TYPE="wix-draft-plugin-video",VIDEO_TYPE_LEGACY="VIDEO-EMBED",videoButtonsTypes={video:"video",soundCloud:"soundCloud",youTube:"youTube"},mediaTypes=[videoButtonsTypes.soundCloud,videoButtonsTypes.youTube];export{VIDEO_TYPE,VIDEO_TYPE_LEGACY,mediaTypes,videoButtonsTypes};
//# sourceMappingURL=types.js.map
